import { type ValueOf } from '@/lib/utils/type'

export const MEMBERS_PER_PAGE = 5
export const MEMBER_ROW_HEIGHT = 49

export const TabItemValues = {
  members: 'members',
  invitesPending: 'invites pending',
} as const
export type TabItemValues = ValueOf<typeof TabItemValues>
export const TAB_ITEMS = [
  {
    label: 'Members',
    value: TabItemValues.members,
  },
  {
    label: 'Invites Pending',
    value: TabItemValues.invitesPending,
  },
]
